var map = {
	"./bars-staggered.svg": "4913",
	"./bullhorn.svg": "1ebd",
	"./comment.svg": "c5f4",
	"./file-invoice.svg": "70e3",
	"./first-section.webp": "8605",
	"./hand-holding-dollar.svg": "315c",
	"./handshake.svg": "173a",
	"./id-card.svg": "3642",
	"./laptop-file.svg": "5e1a",
	"./magnifying-glass-chart.svg": "ffbb",
	"./third-section.webp": "25ba",
	"./users-medical.svg": "0526"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67ed";